var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"legal-header"},[_c('div',{staticClass:"legal-header__logo"},[_c('img',{attrs:{"src":"https://pic3.zhuanstatic.com/zhuanzh/5495ebaa-8836-46ba-86a2-4568db42ebdd.png","alt":"转转"}})])])
}]

export { render, staticRenderFns }